import LegacyContentConfig from './LegacyContentConfig';
import setVar from './util/setVar';

export default class LegacyConfig {
  brisk?: string;
  briskOnlyReporting?: boolean; // force the use of brisk reporting when true.
  disabled?: boolean;
  dontResetSource?: boolean; // Don't reset source when playing through 10.x agent [default: false] See: SRV-712
  rpk?: string;
  timeoutAgentStreaming?: number; // Default timeout for Agent streaming [tvd, and tle override]
  timeoutAgentStreamingLive?: number; // Video on Demand agent streaming timeout
  timeoutAgentStreamingVod?: number; // Live Event agent streaming timeout
  urn?: string;
  usePreRoll?: boolean; // Use preroll when playing through 10.x agent [default: false]
  vodOptOut: boolean; // Opt-out for VOD, Agent 10.6+ only

  constructor(obj?: LegacyConfig, config?: LegacyContentConfig) {
    this.brisk = (obj && obj.brisk) || (config && config.b);
    this.briskOnlyReporting = setVar(false, obj && obj.briskOnlyReporting);
    this.disabled = setVar(false, obj && obj.disabled);
    this.dontResetSource = setVar(false, obj && obj.dontResetSource);
    this.rpk = obj && obj.rpk;
    this.timeoutAgentStreaming =
      (obj && obj.timeoutAgentStreaming) || (config && config.tas);
    this.timeoutAgentStreamingLive =
      (obj && obj.timeoutAgentStreamingLive) || (config && config.tle);
    this.timeoutAgentStreamingVod =
      (obj && obj.timeoutAgentStreamingVod) || (config && config.tvd);
    this.urn = obj && obj.urn;
    this.usePreRoll = setVar(false, obj && obj.usePreRoll);
    this.vodOptOut = setVar(false, obj && obj.vodOptOut, config && config.voo);
  }
}
